import { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router";

const useCloseFullScreenModal = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const handleOnClose = useCallback(() => {
    // if user navigated to this page directly, go back to the integrations list
    if (location.key === "default") {
      navigate(`/integrations/${params.provider}`);
    } else {
      navigate(-1);
    }
  }, [location, navigate, params]);

  return { handleOnClose };
};

export default useCloseFullScreenModal;
